export default __webpack_public_path__ + "static/media/google-calendar.679c3e51.png";